import { render, staticRenderFns } from "./ForcaDeVendaTabela.vue?vue&type=template&id=cea461ae"
import script from "./ForcaDeVendaTabela.vue?vue&type=script&lang=js"
export * from "./ForcaDeVendaTabela.vue?vue&type=script&lang=js"
import style0 from "./ForcaDeVendaTabela.vue?vue&type=style&index=0&id=cea461ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports